export enum ExTransactionStatus {
    STATUS_PENDING = 1,
    STATUS_RECIEVED = 2,
    STATUS_COMPLETED = 3,
    STATUS_ERROR = 4,
    FUNDS_SENT = 5
}
